import React from 'react';

const CheckOut = () => {
    return (
        <div>
            <h1>This is CheckOut</h1>
        </div>
    );
};

export default CheckOut;